<template>
  <div>
    <v-layout class="mb-4">
      <DocumentInfoCard
      v-if="this.enableInfoCard === true"
      :data="{
        btn: 'flat',
        type: 'LINK',
        cdid: this.getUser.pref.select.cdid,
        fdid: this.getUser.pref.select.fdid,
        did: this.getRegisterInfo.did,
        tag: this.getRegisterInfo.tag}"
      />
      <GetRegisterListPage
      :data="{tag: 'K6', tagd: this.tag, tags: this.tag}"
      class="hidden-xs-only"
      v-if="this.enableRegisterRefresh"/>
      <div v-if="this.enableAddNewFromRegister">
        <RiskNew v-if="this.tag === 'B1'"/>
        <BudgetNew v-if="this.tag === 'B4'" :data="{btnTitle: 'New Budget', btnSize: 'flat'}"/>
        <PlanNew v-if="this.tag === 'B6'" :data="{btnTitle: 'New Plan', btnSize: 'flat'}"/>
        <EquipNew v-if="this.tag === 'E1'"/>
        <EngNew v-if="this.tag === 'E2'" :data="{btnTitle: 'New Study', btnSize: 'flat'}"/>
        <!-- <ProgramNew v-if="this.tag === 'E6'"/> -->
        <OpsNew :data="{btnTitle: 'New', btnSize: 'flat'}" v-if="this.tag === 'O1'"/>
        <MaterialNew v-if="this.tag === 'L1'"/>
        <MaintStrategyNew v-if="this.tag === 'M2'"/>
        <HazardNew v-if="
        this.tag === 'S1' &&
        this.enableAccessAuthCreate('S1')
        "/>
        <IncidentNew :data="{btnTitle: 'New Event'}" v-if="this.tag === 'S6'"/>
        <ProcedureNew :data="{btnTitle: 'New Procedure', btnSize: 'flat'}" v-if="this.tag === 'W6'"/>
        <!-- <WorkRequestNew :data="{btnTitle: 'Work Request'}"  v-if="this.tag === 'W1'"/> -->
        <AssetNew
        :data="{btn: 'flat', copy: false, detail: null}"
        v-if="this.tag === 'A1'"/>
      </div>
      <v-spacer/>
      <div v-if ="
      this.tag !== 'A1' &&
      this.tag !== 'M5' &&
      this.tag !== 'O1' &&
      this.tag !== 'W1' &&
      this.tag !== 'W2'
      ">
        <div v-if="btnSpinLoadMore === false">
          <v-btn
          @click="loadNextCheck(defineLoadNextCheck)"
          :color="ui.colorBlue"
          :disabled="this.tag === 'E8'"
          flat dark>
            <v-icon left :color="ui.colorBlue"> cloud </v-icon>
              load more
          </v-btn>
        </div>
        <div v-else>
          <BtnSpin dark :btnSpec="btnInfo1"/>
        </div>
      </div>
      <div v-else>
        <div v-if="btnSpinLoadMore === false">
          <v-btn
          @click="loadNext()"
          :color="ui.colorBlue"
          flat dark>
            <v-icon left :color="ui.colorBlue"> cloud </v-icon>
              load more
          </v-btn>
        </div>
        <div v-else>
          <BtnSpin dark :btnSpec="btnInfo1"/>
        </div>
      </div>

    </v-layout>
</div>
</template>

<script>
import { mapGetters } from "vuex";
import BtnSpin from "@/frame/animation/components/BtnSpin";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import getList from "@/data/cloud/firebase/mixins/getList.js";
import MaintStrategyNew from "@/maintenance/strategy/components/MaintStrategyNew";
import EquipNew from "@/engineering/equipment/components/EquipNew";
import MaterialNew from "@/logistics/material/components/MaterialNew";
import ProcedureNew from "@/work/procedure/components/ProcedureNew";
// import WorkRequestNew from "@/work/request/components/WorkRequestNew";
// import ProgramNew from "@/engineering/program/components/ProgramNew";
import EngNew from "@/engineering/engineering/components/EngNew";
import BudgetNew from "@/business/budget/components/BudgetNew";
import PlanNew from "@/business/plan/components/PlanNew";
import OpsNew from "@/operations/notification/components/OpsNew";
import RiskNew from "@/business/risk/components/RiskNew";
import HazardNew from "@/safety/hazard/components/HazardNew";
import IncidentNew from "@/safety/incident/components/IncidentNew";
import GetRegisterListPage from "@/data/register/components/GetRegisterListPage";
import AssetNew from "@/asset/asset/components/AssetNew";
import DocumentInfoCard from "@/document/info/components/DocumentInfoCard";
import accessFunctions from "@/support/access/mixins/accessFunctions.js";

export default {
  components: {
    BtnSpin,
    MaintStrategyNew,
    EquipNew,
    EngNew,
    MaterialNew,
    ProcedureNew,
    // ProgramNew,
    RiskNew,
    PlanNew,
    BudgetNew,
    HazardNew,
    AssetNew,
    OpsNew,
    IncidentNew,
    // WorkRequestNew,
    GetRegisterListPage,
    DocumentInfoCard
  },
  mixins: [apptheme, getList, accessFunctions],
  data() {
    return {
      btnSpinLoadMore: false,
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user",
        btnType: ""
      }
    };
  },
  beforeMount() {
    if (this.tag === "B6.W") {
      let plandid = this.getRegisterInfo.did;
      this.$store.dispatch("changePlanDID", plandid);
    }
  },
  computed: {
    ...mapGetters([
      "getUser",
      "getSearchResults",
      "getRegisterInfo",
      "getCurrentPage"
    ]),
    defineLoadNextCheck() {
      let info = null;
      if (this.getRegisterInfo !== null) {
        if (this.getRegisterInfo.tag === "F1") {
          info = "link.fdid";
        }
      }
      return info;
    },
    tag() {
      let tag = null;
      if (this.getRegisterInfo !== null) {
        if (this.getRegisterInfo.tag === "B6") {
          tag = "B6.W";
        } else if (this.getRegisterInfo.tag === "B4") {
          tag = "B4.Q1";
        } else {
          tag = this.getSearchResults[0].basic.tag;
        }
      } else {
        tag = this.getSearchResults[0].basic.tag;
      }
      return tag;
    },
    enableAddNewFromRegister() {
      let logic = null;
      let tag = this.getSearchResults[0].basic.tag;
      let arch = this.getSearchResults[0].basic.ver;
      if (tag !== null && arch !== "A") {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    enableInfoCard() {
      let logic = false;
      if (this.getRegisterInfo !== null && this.getRegisterInfo !== undefined) {
        if (this.getRegisterInfo.tag === "M2") {
          logic = true;
        }
        if (this.getRegisterInfo.tag === "M5") {
          logic = true;
        }
      }
      return logic;
    },
    enableRegisterRefresh() {
      let logic = false;
      if (
        this.getRegisterInfo !== null &&
        this.getCurrentPage === "/registerlist"
      ) {
        let tag = this.getSearchResults[0].basic.tag;
        // eslint-disable-next-line
        if (
          tag !== this.getRegisterInfo.tag &&
          (this.getRegisterInfo.tag === "U1" && tag !== "B3") &&
          tag !== "W1" &&
          tag !== "M7"
        ) {
          logic = true;
        } else {
          logic = false;
        }
      } else {
        logic = true;
      }
      // it is working but it desbale
      logic = false;
      return logic;
    }
  }
};
</script>
